import React, { useState } from 'react';
import Modal from '../common/Modal';
import Input from '../common/Input';
import Button from '../common/Button';
import { transactionService } from '../../services/transactionService';
import { useNotification } from '../../hooks/useNotification';

const AddDebtModal = ({ isOpen, onClose, debtor, onSuccess }) => {
  const { showSuccess, showError } = useNotification();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    amount: '',
    notes: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await transactionService.create(debtor._id, {
        type: 'debt',
        amount: parseFloat(formData.amount),
        notes: formData.notes
      });

      showSuccess('Debt added successfully!');

      // Check for threshold alert
      if (response.data.alert?.thresholdExceeded) {
        showError(response.data.alert.message);
      }

      setFormData({ amount: '', notes: '' });
      onClose();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error adding debt:', error);
      showError(error.message || 'Failed to add debt. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ amount: '', notes: '' });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Add Debt">
      <div className="mb-4">
        <p className="text-sm text-gray-600">
          Adding debt for: <strong>{debtor?.name}</strong>
        </p>
        <p className="text-sm text-gray-600">
          Current outstanding: <strong className="text-red-600">{debtor?.totalOutstanding.toFixed(3)} BHD</strong>
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <Input
          label="Amount (BHD)"
          type="number"
          step="0.001"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
          placeholder="0.000"
          required
        />

        <div className="mb-4">
          <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1">
            Notes (Optional)
          </label>
          <textarea
            id="notes"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            placeholder="What was purchased..."
            rows="3"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>

        <div className="flex gap-3 justify-end">
          <Button type="button" variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" loading={loading}>
            Add Debt
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AddDebtModal;
